import axios from "axios";
export default {
  async getAppSettings() {
    let appSettings = null;
    appSettings = await axios.get("settings/app-settings.config.json");
    return appSettings;
  },
};
